import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import './Assets/CSS/ColorTheme.css';
import './Assets/CSS/Style.css';
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Login from "./Account/Login";
import ValidationPage from "./Account/ValidationPage";
import Dashboard from "./Account/Dashboard";
import SearchClient from "./Pages/SearchClient";
import InsuranceWorkflow from "./Pages/InsuranceWorkflow";
import ContactInformation from "./Pages/ContactInformation";
import DriverInformation from "./Pages/DriverInformation";
import VehicleInformation from "./Pages/VehicleInformation";
import PolicyCoverage from "./Pages/PolicyCoverage";
import Review from "./Pages/Review";
import ProcessingApplication from "./Pages/ProcessingApplication";
import CompareQuotes from "./Pages/CompareQuotes";
import Configuration from "./Pages/Configurations/Configuration";
import History from "./Pages/History";
import SelectQuoteFlow from "./Pages/SelectQuoteFlow";
import RabbitSignPage from "./Pages/RabbitSignPage ";
function App() {
  return (
    <div className="">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route path="/acevalidation" element={<ValidationPage />}></Route>
          <Route path="/dashboard" element={<Dashboard />}></Route>
          <Route path="/search-client" element={<SearchClient />}></Route>
          <Route path="/insurance-workflow" element={<InsuranceWorkflow />}></Route>
          <Route path="/contact-information" element={<ContactInformation />}></Route>
          <Route path="/driver-information" element={<DriverInformation />}></Route>
          <Route path="/vehicle-information" element={<VehicleInformation />}></Route>
          <Route path="/policy-coverage" element={<PolicyCoverage />}></Route>
          <Route path="/review" element={<Review />}></Route>
          <Route path="/processing-application" element={<ProcessingApplication />}></Route>
          <Route path="/quote-comparison" element={<CompareQuotes />}></Route>
          <Route path="/configuration" element={<Configuration />}></Route>
          <Route path="/history" element={<History />}></Route>
          <Route path="/select-quote-flow" element={<SelectQuoteFlow />} />
          <Route path="/rabbit-sign" element={<RabbitSignPage />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
